import React from 'react';
import cl from './HomeInfo.module.css';
import { NavLink } from 'react-router-dom';

import sale from "../../../image/sale.svg";
import about from "../../../image/about.svg";

const HomeInfo = (props) => {
  return (
    <section className={cl.about}>
      <NavLink className={cl.link_image} to="/products">
        <p className={cl.big_image}>
          <img
            src={sale}
            alt="call"
            width="25px"
            height="25px"
            style={{ marginRight: "10px" }}
          />
          SALE
        </p>
       
      </NavLink>
      <NavLink className={cl.link_image} to="/about">
        <p className={cl.big_image}>
          <img
            src={about}
            alt="call"
            width="25px"
            height="25px"
            style={{ marginRight: "10px" }}
          />
          ABOUT US
        </p>
      
      </NavLink>
    </section>
  );
};

export default HomeInfo;
